import { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { inviteServices } from "../../APIServices/UserData/inviteServices";

const InviteNewMember = ({ Show, Hide, Title, getInvitation, isDark, auth, accountList }) => {
  const [email, setEmail] = useState("");
  const [assignedAccount, setAssignedAccount] = useState([]);
  const [loader, setLoader] = useState(false);

  const inviteUser = async () => {
    let userData = {}
    setLoader(true)
    userData.email = email
    userData.assignedAccount = assignedAccount
    let data = await inviteServices.inviteUser(auth, userData)
    if (data?.statusCode === 200) {
      setEmail("")
      setAssignedAccount([])
      getInvitation()
      Hide()
    }
    setLoader(false)
  }

  const handleCheckbox = (userId, checked) => {
    if (checked) {
      setAssignedAccount((prev) => [...prev, userId]);
    } else {
      setAssignedAccount((prev) => prev.filter((id) => id !== userId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setAssignedAccount(accountList.map((m) => m.accountId));
    } else {
      setAssignedAccount([]);
    }
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Email{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Email"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Assign Account{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          {accountList?.length > 0 && (
            <Form.Check
              type="checkbox"
              label="Select All"
              checked={assignedAccount?.length === accountList?.length}
              onChange={(e) => handleSelectAll(e.target.checked)}
              style={{ fontSize: 12 }}
            />
          )}
          {accountList?.map((item, index) => (
            <Form.Check
              key={index}
              type="checkbox"
              label={item?.name}
              checked={assignedAccount?.includes(item.accountId)}
              onChange={(e) => handleCheckbox(item.accountId, e.target.checked)}
              style={{ fontSize: 12 }}
            />
          ))}
        </Form.Group>
      </Offcanvas.Body>
      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}>
        <Button
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
          disabled={!email || assignedAccount?.length === 0 || loader}
          onClick={inviteUser}
        >
          {Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default InviteNewMember;
